import { render } from "./MenuLogo.vue?vue&type=template&id=faadb874&scoped=true"
import script from "./MenuLogo.vue?vue&type=script&lang=js"
export * from "./MenuLogo.vue?vue&type=script&lang=js"

import "./MenuLogo.vue?vue&type=style&index=0&id=faadb874&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faadb874"]])

export default __exports__